var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment-dots-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06006 10.763C5.07146 11.6314 5.47916 12.4604 6.19347 13.0674C6.90777 13.6745 7.87015 14.0098 8.86886 13.9998H10.7144C11.2162 14.0002 11.6961 14.1788 12.0429 14.4942L13.0263 15.3886C13.1819 15.5257 13.3942 15.6028 13.6156 15.6028C13.837 15.6028 14.0493 15.5257 14.2049 15.3886L15.7321 13.9998L16.2335 13.5134C16.3258 13.4262 16.4265 13.3459 16.5343 13.2734C17.4202 12.6679 17.9381 11.7428 17.9401 10.763V6.83503C17.9153 5.02721 16.2103 3.57894 14.1313 3.59983H8.86886C6.78985 3.57894 5.08481 5.02721 5.06006 6.83503V10.763Z",
    stroke: "#197A56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8999 8.79997C6.8999 8.35818 7.3118 8 7.8199 8C8.328 8 8.7399 8.35818 8.7399 8.79997C8.7399 9.24181 8.328 9.59997 7.8199 9.59997C7.5759 9.59997 7.3419 9.51573 7.16936 9.36573C6.99683 9.21565 6.8999 9.01221 6.8999 8.79997Z",
    stroke: "#197A56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5801 8.79997C10.5801 8.35818 10.992 8 11.5001 8C12.0082 8 12.4201 8.35818 12.4201 8.79997C12.4201 9.24181 12.0082 9.59997 11.5001 9.59997C10.992 9.59997 10.5801 9.24181 10.5801 8.79997Z",
    stroke: "#197A56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2598 8.79997C14.2598 8.35818 14.6716 8 15.1798 8C15.6879 8 16.0998 8.35818 16.0998 8.79997C16.0998 9.24181 15.6879 9.59997 15.1798 9.59997C14.6716 9.59997 14.2598 9.24181 14.2598 8.79997Z",
    stroke: "#197A56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.d15dbd8d78a1a0961865a2c483753cf0.svg";
export { ForwardRef as ReactComponent };